<template>
	<div class="points-details-wrapper">
		<div class="points-header">
			<h3 class="section-title">积分明细</h3>
			<span class="points-count">共 {{ allData.length }} 条记录</span>
		</div>

		<div class="table-container" v-if="allData.length > 0">
			<el-table 
				:data="displayList" 
				class="modern-table"
				:header-cell-style="headerCellStyle"
				:cell-style="cellStyle">
				<el-table-column prop="remark" label="积分来源" min-width="200">
					<template slot-scope="scope">
						<div class="source-cell">
							<i class="el-icon-coin"></i>
							<span>{{ scope.row.remark }}</span>
						</div>
					</template>
				</el-table-column>
				<el-table-column prop="integral" label="积分值" width="150" align="center">
					<template slot-scope="scope">
						<span class="points-value">+{{ scope.row.integral }}</span>
					</template>
				</el-table-column>
				<el-table-column prop="createTime" label="创建时间" width="200" align="center">
					<template slot-scope="scope">
						<span class="time-cell">
							<i class="el-icon-time"></i>
							{{ scope.row.createTime }}
						</span>
					</template>
				</el-table-column>
			</el-table>
			
			<!-- 加载更多按钮 -->
			<div class="load-more-wrapper" v-if="hasMore">
				<el-button type="text" class="load-more-btn" @click="loadMore">
					<i class="el-icon-arrow-down"></i>
					加载更多
				</el-button>
			</div>
			<div class="no-more" v-else-if="allData.length > pageSize">
				已加载全部
			</div>
		</div>

		<div class="empty-state" v-else>
			<i class="el-icon-star-off"></i>
			<p>暂无积分记录</p>
		</div>
	</div>
</template>

<script>
	import {
		pointDetails
	} from "@/api/index"
	export default {
		data() {
			return {
				allData: [],
				pageSize: 10,
				displayCount: 10,
				headerCellStyle: {
					background: '#F7F8FA',
					color: '#606266',
					fontWeight: '500',
					fontSize: '14px',
					borderBottom: '1px solid #EBEEF5'
				},
				cellStyle: {
					color: '#303133',
					fontSize: '14px'
				}
			}
		},
		computed: {
			displayList() {
				return this.allData.slice(0, this.displayCount)
			},
			hasMore() {
				return this.displayCount < this.allData.length
			}
		},
		mounted() {
			this.getInfo()
		},
		methods: {
			getInfo() {
				pointDetails().then(res => {
					if (res.code === "0000") {
						this.allData = res.data
					}
				})
			},
			loadMore() {
				this.displayCount += this.pageSize
			}
		}
	}
</script>

<style lang="scss" scoped>
.points-details-wrapper {
	padding: 0 30px;
}

.points-header {
	display: flex;
	align-items: center;
	justify-content: space-between;
	margin-bottom: 20px;
}

.section-title {
	font-size: 18px;
	color: #303133;
	margin: 0;
	font-weight: 500;
	padding-left: 12px;
	border-left: 3px solid #409EFF;
}

.points-count {
	font-size: 13px;
	color: #909399;
}

.table-container {
	background: #FFFFFF;
	border-radius: 8px;
	overflow: hidden;
	border: 1px solid #EBEEF5;
}

.modern-table {
	width: 100%;
}

.modern-table ::v-deep .el-table__header-wrapper {
	background: #F7F8FA;
}

.modern-table ::v-deep .el-table__row {
	transition: background 0.2s ease;

	&:hover > td {
		background: #F5F7FA !important;
	}
}

.modern-table ::v-deep .el-table__body tr:nth-child(even) {
	background: #FAFBFC;
}

.modern-table ::v-deep td.el-table__cell {
	border-bottom: 1px solid #F0F2F5;
}

.modern-table ::v-deep .el-table__empty-block {
	min-height: 200px;
}

.source-cell {
	display: flex;
	align-items: center;
	color: #303133;

	i {
		margin-right: 10px;
		color: #E6A23C;
		font-size: 16px;
	}
}

.points-value {
	display: inline-block;
	padding: 4px 12px;
	background: #F0F9EB;
	color: #67C23A;
	border-radius: 4px;
	font-weight: 500;
	font-size: 14px;
}

.time-cell {
	color: #909399;
	font-size: 13px;

	i {
		margin-right: 6px;
	}
}

.empty-state {
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;
	padding: 80px 0;
	color: #C0C4CC;

	i {
		font-size: 48px;
		margin-bottom: 16px;
	}

	p {
		font-size: 14px;
		margin: 0;
	}
}

.load-more-wrapper {
	text-align: center;
	padding: 24px 0;
	border-top: 1px solid #F0F2F5;
}

.load-more-btn {
	color: #409EFF;
	font-size: 14px;
	padding: 12px 40px;
	border-radius: 22px;
	border: 1px solid #409EFF;
	background: #FFFFFF;
	transition: all 0.3s ease;

	i {
		margin-right: 8px;
		transition: transform 0.3s ease;
	}

	&:hover {
		background: #409EFF;
		color: #FFFFFF;
		box-shadow: 0 4px 12px rgba(64, 158, 255, 0.3);

		i {
			transform: translateY(2px);
		}
	}
}

.no-more {
	text-align: center;
	padding: 20px 0;
	color: #C0C4CC;
	font-size: 13px;
	border-top: 1px solid #F0F2F5;
}
</style>
